import classNames from 'classnames'
import React, { ReactNode } from 'react'

export type RadioInputAttributes = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'type' | 'checked' | 'defaultRadioed' | 'value' | 'onChange' | 'disabled' | 'aria-invalid'
>

export interface RadioProps {
    id: string
    label: ReactNode
    value: string
    checked?: boolean
    className?: string
    styles?: React.CSSProperties
    input?: RadioInputAttributes
    isDisabled?: boolean
    isInvalid?: boolean
    onChange?: (checked: boolean) => void
}

export const Radio = (props: RadioProps): JSX.Element => {
    const { input, checked, value, isDisabled, isInvalid, id, styles } = props

    const className: string = classNames(
        'radio',
        isDisabled && 'is-disabled',
        isInvalid && 'is-invalid',
        props.className,
    )

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const nextValue = event.currentTarget.checked

        if (isDisabled) {
            return
        }

        if (props.onChange) {
            props.onChange(nextValue)
        }
    }

    return (
        <div className={className} style={styles}>
            <input
                {...input}
                type="radio"
                checked={checked}
                disabled={isDisabled}
                value={value}
                onChange={onChange}
                id={id}
                className="radio__input"
                aria-invalid={isInvalid}
            />
            <label htmlFor={id} className="radio__label">
                {props.label}
            </label>
            <div className="radio__inner">
                <span className="radio__indicator" />
            </div>
        </div>
    )
}
